import React from 'react'

import PropTypes from 'prop-types'
import { pick } from 'ramda'

import Icon from '~/src/UI/Shared/Icon'

import { schemaFormatters } from './utils'

const displayName = 'AnnotationIcon'

const passthruCleaner = pick(['color', 'className', 'fontSize', 'style'])
export const AnnotationIconComponent = props => {
  const { icon: propsIcon, schema, ...passthru } = props
  const { [schema]: formatters } = schemaFormatters

  const icon = formatters?.icon
    ?? formatters?.icons?.[propsIcon]
    ?? formatters?.icons?.default
    ?? propsIcon
  const IconFormatter = icon?.getIcon

  return IconFormatter || icon ? (
    <Icon
      {...passthruCleaner(passthru)}
      icon={IconFormatter ? <IconFormatter {...props} /> : icon}
    />
  ) : null
}

AnnotationIconComponent.propTypes = {
  icon: PropTypes.node.isRequired,
  schema: PropTypes.string.isRequired,
}

AnnotationIconComponent.displayName = displayName

const Memoized = React.memo(AnnotationIconComponent)

export default Memoized
